import api from '@/config/Api'

export default {
  getInfo () {
    return api.get(`/administration/info`)
  }
}
